import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

// PrimeNG imports
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

// Services and ViewModels
import { DataPreparationViewModel } from '../viewmodels/data-preparation.viewmodel';
import { DataPreparationService } from '../services/data-preparation.service';
import { ToastService } from '../../../toast/toast.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-data-preparation-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    DialogModule,
    FileUploadModule,
    TooltipModule,
    ConfirmDialogModule,
    ProgressBarModule,
    FluidModule,
    IconFieldModule,
    InputIconModule
  ],
  templateUrl: './data-preparation-list.component.html',
  styleUrl: './data-preparation-list.component.scss',
  providers: [DataPreparationViewModel, ConfirmationService]
})
export class DataPreparationListComponent implements OnInit {
  private router = inject(Router);
  private http = inject(HttpClient);
  private dataPreparationService = inject(DataPreparationService);
  private toastService = inject(ToastService);
  private confirmationService = inject(ConfirmationService);
  
  viewModel!: DataPreparationViewModel;

  ngOnInit(): void {
    this.viewModel = new DataPreparationViewModel(
      this.http,
      this.toastService,
      this.confirmationService,
      this.router
    );
    
    this.viewModel.initialize();
  }


  onFileSelect(event: any): void {
    this.viewModel.onFileSelect(event);
  }


  clearFile(): void {
    this.viewModel.selectedFile = null;
  }


  formatFileSize(bytes: number | undefined): string {
    if (!bytes) return '-';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  
  formatDate(date: Date | undefined): string {
    if (!date) return '-';
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${month}/${day}/${year} ${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
  }
}
